<template>
	<span class="badge-marketing-kit" v-if="isMarketingKitEnabled" v-tooltip="'Marketing kit'">
        <img src="https://cdn.ostock.id/icons/marketing_kit.svg" alt="" srcset="">
    </span>
</template>

<script>
export default {
	name: 'BadgeMarketingKit',
	props: {
		isMarketingKitEnabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.badge-marketing-kit img {
    width: 20px;
}
</style>
